import { useState } from "react";
import { deleteFile, downloadFile, renameFile, createFolder } from "./ftpService";
import { ArrowDownTrayIcon, TrashIcon, PencilIcon, FolderPlusIcon, CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";

export default function FileActions({ file, fetchFiles }) {
  const [isRenaming, setIsRenaming] = useState(false);
  const [newName, setNewName] = useState(file.name);

  const handleDelete = async () => {
    if (window.confirm(`Voulez-vous vraiment supprimer ${file.name} ?`)) {
      await deleteFile(file.name);
      fetchFiles();
    }
  };

  const handleDownload = () => {
    downloadFile(file.name);
  };

  const handleRename = async () => {
    if (!newName || newName === file.name) {
      setIsRenaming(false);
      return;
    }
    await renameFile(file.name, newName);
    setIsRenaming(false);
    fetchFiles();
  };

  const handleCreateFolder = async () => {
    const folderName = prompt("Nom du nouveau dossier :");
    if (folderName) {
      await createFolder(folderName);
      fetchFiles();
    }
  };

  return (
    <div className="flex items-center space-x-1">
      {isRenaming ? (
        <div className="flex items-center space-x-1">
          <input
            type="text"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1 text-sm w-24"
          />
          <button onClick={handleRename} className="text-green-500 hover:text-green-700">
            <CheckIcon className="w-4 h-4" />
          </button>
          <button onClick={() => setIsRenaming(false)} className="text-gray-500 hover:text-gray-700">
            <XMarkIcon className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <button onClick={() => setIsRenaming(true)} className="text-yellow-500 hover:text-yellow-700">
          <PencilIcon className="w-4 h-4" />
        </button>
      )}

      {file.type !== "directory" && (
        <>
          <button onClick={handleDownload} className="text-blue-500 hover:text-blue-700">
            <ArrowDownTrayIcon className="w-4 h-4" />
          </button>
          <button onClick={handleDelete} className="text-red-500 hover:text-red-700">
            <TrashIcon className="w-4 h-4" />
          </button>
        </>
      )}

      {file.type === "directory" && (
        <button onClick={handleCreateFolder} className="text-gray-500 hover:text-gray-700">
          <FolderPlusIcon className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
